import type { PropsWithChildren } from 'react'

import styled from 'styled-components'

export type CardHoverInformationProps = PropsWithChildren<unknown>

const Box = styled.div`
  bottom: 0;
  z-index: 3;
  transform: translateY(100%);
  transition: transform calc(var(--timing) / 2) var(--easing);
`

const CardHoverInformation = ({ children }: CardHoverInformationProps) => {
  return (
    <Box className='_w-full _position-absolute _d-block _rounded-bottom card-hover-information'>
      {children}
    </Box>
  )
}

export default CardHoverInformation
